import { useContext } from 'react';
import { DedicatedAssignmentContext } from '../contexts/dedicated_assignment_context';

const useDedicatedAssignment = () => {
    return useContext(DedicatedAssignmentContext);
};

export default useDedicatedAssignment;
